// ──────────────────────────────────────────────────────────────────────────────
// CHANGELOG DO SISTEMA
// Para publicar uma nova atualização:
//   1. Incremente APP_VERSION
//   2. Adicione um novo objeto no início do array CHANGELOG
// ──────────────────────────────────────────────────────────────────────────────

export const APP_VERSION = '1.8.0';

export type ChangeType = 'new' | 'fix' | 'improve';

export interface ChangeItem {
  type: ChangeType;
  text: string;
}

export interface ChangelogEntry {
  version: string;
  date: string;
  title: string;
  items: ChangeItem[];
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    version: '1.8.0',
    date: '02/10/2026',
    title: 'Lacres no Orçamento Rápido',
    items: [
      { type: 'new',     text: 'Nova aba "Lacres" no Orçamento Rápido — 18 pacotes prontos no material Brilho, do 2,5x7 cm ao 4,5x29 cm (bolo no pote, potes, sacolas, copos, brigadeiro, cinta, coração, delivery e mais)' },
      { type: 'new',     text: 'Cada lacre já vem com quantidade e preço no select (ex.: "4x9 cm - Bolo no pote (250un) - R$ 49,99"), com prévia de PIX, Cartão e total de unidades antes de adicionar' },
      { type: 'new',     text: 'Lacres entram normalmente no orçamento: somam nos totais, aparecem no resumo lateral e no texto gerado para o cliente' },
    ],
  },
  {
    version: '1.7.0',
    date: '25/09/2026',
    title: 'Pedidos Trocados & Painel',
    items: [
      { type: 'new',     text: 'Nova tela "Pedidos Trocados" em OPERAÇÕES — registre quando um pedido foi entregue trocado: responsável, os dois pedidos envolvidos e o contato de cada cliente, lado a lado para identificar a troca de imediato' },
      { type: 'new',     text: 'Situação da troca alterável por um clique (modal): Em análise e Resolvido' },
      { type: 'new',     text: 'Cards de resumo clicáveis em Pedidos Trocados (Trocas no período, Em análise e Resolvidos) que filtram a lista, além de busca e filtro por período' },
      { type: 'new',     text: 'Badge de pendências em Pedidos Trocados — conta as trocas que ainda estão "Em análise"' },
      { type: 'improve', text: 'Painel — "Faturamento do Mês Anterior" agora aparece em primeiro no Resumo de Atividades' },
      { type: 'new',     text: 'Painel — três novas informações no Resumo de Atividades: Pedidos Extraviados (Mês), Pedidos Trocados (Mês) e Valor dos Erros Internos (Mês) em R$' },
    ],
  },
  {
    version: '1.6.0',
    date: '20/07/2026',
    title: 'Promoções & Artes por Fora',
    items: [
      { type: 'new',     text: 'Banners promocionais no Orçamento Rápido — o modal "Preço por m²" agora traz as promoções: 0,50x0,80m por R$ 39,99 PIX / R$ 44,43 cartão e 0,80x1,20m por R$ 59,99 PIX / R$ 66,65 cartão' },
      { type: 'new',     text: 'Novo campo "Artes por fora (Ex: Shopee)" na interface do designer — registre as artes feitas fora do sistema; o valor do dia soma no seu total de artes do mês' },
      { type: 'new',     text: 'Coluna "Externas" no Desempenho Arte, mostrando quantas artes por fora cada designer lançou no período (já somadas no Total de Artes)' },
    ],
  },
  {
    version: '1.5.0',
    date: '20/07/2026',
    title: 'Reposição & Badges',
    items: [
      { type: 'new',     text: 'Nova tela "Reposição" em OPERAÇÕES — acompanhe reposições do pedido até a finalização. Disponível para todos os perfis' },
      { type: 'new',     text: 'Situações da reposição alteráveis por um clique (modal): Reposição encaminhada, Impressão, Corte e Finalizado' },
      { type: 'new',     text: 'Data e hora da finalização registradas automaticamente ao marcar como "Finalizado" — e limpas caso a situação volte atrás' },
      { type: 'new',     text: 'Badge de pendências na Reposição — conta tudo que ainda não foi finalizado' },
      { type: 'fix',     text: 'Badges do menu (Extraviados, Atrasados, Erros Internos, Estornos e Verificar Pedido) voltaram a atualizar para todos os perfis — antes ficavam zerados para Vendedor, Designer e Produção' },
    ],
  },
  {
    version: '1.4.0',
    date: '07/07/2026',
    title: 'Verificação de Pedidos',
    items: [
      { type: 'new',     text: 'Nova tela "Verificar Pedido" em OPERAÇÕES — consulte e acompanhe pedidos com situação, observação e anexo. Disponível para todos os perfis' },
      { type: 'new',     text: 'Situação alterável por um clique (modal): Verificar, Verificado, Em Transporte, Não Localizado, Impressão, Corte e Recorte' },
      { type: 'new',     text: 'Anexe o print do pedido por upload ou colando direto com Ctrl+V — sem precisar salvar no computador' },
      { type: 'new',     text: 'Miniatura do print na listagem e visualização ampliada ao clicar' },
      { type: 'new',     text: 'Badge de pendências no menu — conta os pedidos na situação "Verificar" e diminui conforme são resolvidos' },
      { type: 'new',     text: 'Busca por nº do pedido ou telefone e filtros por situação e período' },
    ],
  },
  {
    version: '1.3.2',
    date: '07/07/2026',
    title: 'Produtividade dos Designers',
    items: [
      { type: 'fix',     text: 'Cálculo de artes por designer no Desempenho Arte corrigido — os totais não inflam mais (antes as artes eram recontadas a cada sincronização de pedidos)' },
      { type: 'improve', text: 'Média de artes por dia agora considera apenas os dias realmente trabalhados' },
      { type: 'improve', text: 'Ranking de Produtividade simplificado — removidas as colunas "Artes/Semana" e "Artes/Mês", que geravam confusão' },
    ],
  },
  {
    version: '1.3.1',
    date: '21/06/2026',
    title: 'Navegação & Atendimento Arte',
    items: [
      { type: 'improve', text: 'Atendimento Arte — ao visualizar pedidos de um designer, o nome dele aparece no título e subtítulo da página' },
      { type: 'improve', text: 'Botão "Voltar à página anterior" adicionado globalmente no cabeçalho para facilitar a navegação em todas as telas' },
    ],
  },
  {
    version: '1.3.0',
    date: '21/06/2026',
    title: 'Operações & Logística',
    items: [
      { type: 'new',     text: 'Nova aba "Pedidos Atrasados" em OPERAÇÕES — cadastro de atrasos por transportadora com Nº do pedido, valor do frete e ocorrência' },
      { type: 'new',     text: 'Navegação por período (mês/ano ou dia específico) na aba Pedidos Atrasados, igual às demais operações' },
      { type: 'new',     text: 'Novas transportadoras na Calculadora de Frete: LATAM Cargo, JET e DOM' },
      { type: 'improve', text: 'Select de transportadoras dos Pedidos Atrasados ampliado: Total, Correios, ECOM, SEDEX, PAC, Total Express, LATAM Cargo, JET, DOM, Clube Flex, Expresso e J&T' },
      { type: 'fix',     text: 'Valor Total em Pedidos Estornados corrigido para somar apenas os estornos do mês/período selecionado (antes somava todos os meses)' },
      { type: 'new',     text: 'Popup de "Novas Atualizações" e aba "Sobre" com o histórico completo de versões do sistema' },
    ],
  },
  {
    version: '1.2.0',
    date: '24/05/2026',
    title: 'Performance & Produtividade',
    items: [
      { type: 'new',     text: 'Gráfico "Evolução de Produtividade" no Desempenho Arte agora usa dados reais por semana/dia/mês conforme o período selecionado' },
      { type: 'new',     text: 'Seção "Performance Individual - Designers" adicionada ao Desempenho Vendas com sistema de gratificação por tier (metas de artes/dia)' },
      { type: 'new',     text: 'Gráfico de Distribuição de Clientes (Novos vs Recorrentes) no Dashboard CRM com filtro mensal' },
      { type: 'new',     text: 'Campo "Primeira venda?" adicionado ao cadastro de vendas — alimenta o gráfico de distribuição' },
      { type: 'improve', text: 'Campo "Prazo" no Atendimento Arte agora exibe data e horário reais de entrada do pedido no CRM' },
      { type: 'new',     text: 'Sistema de notificações in-app (sino) — alertas de erros internos e prioridades urgentes' },
    ],
  },
  {
    version: '1.1.0',
    date: '01/05/2026',
    title: 'Operações & Permissões',
    items: [
      { type: 'new',     text: 'Badges de Pedidos Extraviados e Erros Internos mostram apenas itens ativos do mês corrente' },
      { type: 'fix',     text: 'Controle de Prioridades agora exibe todos os pedidos lançados sem limite de 100' },
      { type: 'improve', text: 'Responsável nos Erros Internos virou lista selecionável (antes era campo de texto livre)' },
      { type: 'fix',     text: 'Valor Total dos Erros Internos corrigido para exibir apenas o valor do período selecionado' },
      { type: 'improve', text: 'Suporte e Gerência podem agora alterar prioridade no Atendimento Arte e registrar erros internos' },
      { type: 'new',     text: 'Coluna "Data de Criação" adicionada ao Controle de Prioridades' },
    ],
  },
];
